module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "share-header"
  }, [_c('div', {
    staticClass: "share-header-logo"
  }, [_c('img', {
    staticStyle: {
      "height": "50px",
      "padding-top": "8px"
    },
    attrs: {
      "src": 'static/logo.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "share-header-logo",
    attrs: {
      "href": "https://www.sdgsystems.com/phototag",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "50px",
      "padding-top": "8px"
    },
    attrs: {
      "src": 'static/sdg_logo.png',
      "alt": "SDG"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "share-actions"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleSelectAll
    }
  }, [_vm._v("\n      " + _vm._s(_vm.allSelected ? 'Deselect All' : 'Select All') + "\n    ")])], 1), _vm._v(" "), _c('ImageList', {
    ref: "imageList",
    attrs: {
      "public": true,
      "shareId": _vm.shareId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426e3815","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Public.vue
// module id = 437
// module chunks = 1